/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IERC721Receiver__factory } from "./IERC721Receiver__factory";
